/**
 * Wire adapter: `IntegrationPatientSearchResultItem`
 * (`@heidi/integrations/ehr/contracts`) -> `EhrPatientSearchResultView`
 * (`@heidi/patients`).
 *
 * App composition for the integrations->patients join; the domain DAG refuses
 * this edge by design — this adapter is the boundary contract.
 *
 * `domainAllowList('patients')` grants `patients` + `shared` + `workspace`, so
 * `@heidi/patients` may not name the integrations door. The app layer is the one
 * place both are importable, which is why the mapping lives here and why its own
 * compilation is what reports a rename or a removal on either side.
 *
 * `sex` is on the wire and is not on the view, because the row does not render
 * it. Dropping it is the point of the mapping rather than an omission from it.
 */
import type { IntegrationPatientSearchResultItem } from '@heidi/integrations/ehr/contracts';
import type { EhrPatientSearchResultView } from '@heidi/patients';

export function toEhrPatientSearchResultView(
  wire: IntegrationPatientSearchResultItem
): EhrPatientSearchResultView {
  return {
    patient_id: wire.patient_id,
    first_name: wire.first_name,
    last_name: wire.last_name,
    dob: wire.dob,
    nhs_number: wire.nhs_number,
  };
}
